/**
 * Returns how many days ago a date was, as a Danish string.
 * e.g. "I dag", "1 dag siden", "42 dage siden"
 */
export function daysAgoLabel(dateStr: string): string {
  const found = new Date(dateStr + 'T12:00:00');
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  const days = Math.round((today.getTime() - found.getTime()) / (1000 * 60 * 60 * 24));
  if (days <= 0) return 'I dag';
  if (days === 1) return '1 dag siden';
  return `${days} dage siden`;
}

/**
 * Semester utilities for KK Glemte Sager.
 *
 * Semesters:
 *   F (Forår / Spring): 1 Jan – 30 Jun
 *   E (Efterår / Fall): 1 Jul – 31 Dec
 *
 * Examples: F26, E26, F25, E25 ...
 */

/** Returns the semester label for a given date, e.g. "F26" or "E25". */
export function getSemester(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date + 'T12:00:00') : date;
  const yy = String(d.getFullYear() % 100).padStart(2, '0');
  return d.getMonth() < 6 ? `F${yy}` : `E${yy}`;
}

/** Returns the inclusive date range for a semester label like "F26". */
export function getSemesterRange(semester: string): { start: Date; end: Date } {
  const prefix = semester[0].toUpperCase();
  const year = 2000 + parseInt(semester.slice(1), 10);
  if (prefix === 'F') {
    return { start: new Date(year, 0, 1), end: new Date(year, 5, 30, 23, 59, 59) };
  }
  return { start: new Date(year, 6, 1), end: new Date(year, 11, 31, 23, 59, 59) };
}

/**
 * Returns the last `count` semesters in reverse-chronological order,
 * starting from the current semester.
 */
export function getPastSemesters(count: number): string[] {
  const now = new Date();
  const results: string[] = [];
  let year = now.getFullYear();
  let spring = now.getMonth() < 6;

  for (let i = 0; i < count; i++) {
    const yy = String(year % 100).padStart(2, '0');
    results.push(spring ? `F${yy}` : `E${yy}`);
    if (spring) {
      spring = false;
      year -= 1;
    } else {
      spring = true;
    }
  }

  return results;
}
